export const LANDING_PAGE_CONSTANTS = {
  STATES: 11,
  BRANCHES: 319,
  LIFETIME_CUSTOMERS: 17,
  EMPLOYEES: 2000,
  LAST_YEAR_DISBURSEMENT: 530,
  AUM: 882,
  DATA_EFFECTIVE_DATE: "Data as on 31st March 2025",
  DISTRICTS: 231,
  VILLAGES: 49000,
};
